import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { getIcon } from "@/components/content/iconResolver";

export const AiHubTopic = ({ topic }) => {
  const Icon = getIcon(topic.icon);
  const questions = topic.questions;
  return (
    <section id={topic.id} className="scroll-mt-24" data-testid={`ai-hub-topic-${topic.id}`}>
      <div className="flex items-center gap-3 mb-6">
        <div className="p-2.5 bg-violet-100 rounded-lg text-violet-600">
          <Icon className="h-5 w-5" />
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-slate-900">{topic.title}</h2>
        <Badge className="bg-slate-100 text-slate-600 ml-auto hover:bg-slate-100">
          {questions.length} Q/R
        </Badge>
      </div>
      <div className="space-y-3">
        {questions.map((qa) => (
          <AiHubQa key={qa.q} q={qa.q} a={qa.a} topicId={topic.id} />
        ))}
      </div>
    </section>
  );
};

const AiHubQa = ({ q, a }) => (
  <Card className="border-slate-200 hover:border-violet-200 transition-colors">
    <CardContent className="p-5">
      <h3 className="font-semibold text-slate-900 mb-2 text-base md:text-lg">{q}</h3>
      <p className="text-slate-700 leading-relaxed">{a}</p>
    </CardContent>
  </Card>
);
